export const errorMessage: string = 'Something went wrong!';

// promo constants
export const NEW_EVENT_PROMO_ID: string = '0';

//widget class
export const HIDE_WIDGET_ICON_CLASS = 'hide-widget-icon';

// simulator constants
export const AT_LEAST_ONE_KPI_MUST_BE_SELECTED = 'At least one KPI must be selected';
